import { createFileRoute, notFound, stripSearchParams } from "@tanstack/react-router";

import { checklistTemplatesQueries } from "@/api/resources/checklistTemplates/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import { ChecklistTemplatesPage } from "@/components/ChecklistTemplate/ChecklistTemplatesPage";
import { dataTableSearchSchema, DEFAULT_DATATABLE_OPTIONS } from "@/configs/datatable";
import i18n from "@/providers/i18n";
import { Icon } from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/knowledge-hub/checklist-templates/")({
  validateSearch: dataTableSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_DATATABLE_OPTIONS)],
  },
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.knowledge-hub-checklist-templates"),
        icon: <Icon.CHECKLIST_TEMPLATES />,
        path: "/workspaces/$workspace_id/knowledge-hub/checklist-templates",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();

    await context.queryClient.ensureQueryData(
      checklistTemplatesQueries.list({
        _workspace_id: workspace_id,
        _with_local: true,
        _with_shared: true,
        _with_public: false,
      }),
    );
  },
  component: ChecklistTemplatesPage,
});
